import React, { useCallback, useEffect, useState } from "react";
import { Edit, Delete } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "store/hooks";

import { CoverageCatalogCategoriesResponse } from "store/modules/Catalog/types.store";
import {
  handleDeleteCategoryRequest,
  handleGetCatalogCategoriesRequest,
} from "store/modules/Catalog/thunk.store";
import { useTranslation } from "react-i18next";
import * as Styled from "./styles";
import UpdateCatalogModal from "./components/UpdateCatalogModal";

interface Data {
  type: any;
  action: any;
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}
export const useCategories = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  const [Categories, setCategories] =
    useState<CoverageCatalogCategoriesResponse | null>();

  const [edit, setEdit] = useState<boolean>(false);
  const [selected, setSelected] = useState(null);

  const { catalogCategories } = useAppSelector((state) => state.catalog);

  const HandleCatalogProducts = useCallback(() => {
    setCategories(catalogCategories);
  }, [catalogCategories]);

  useEffect(() => {
    if (!catalogCategories?.data) {
      dispatch(handleGetCatalogCategoriesRequest());
    }
    if (catalogCategories?.data) {
      HandleCatalogProducts();
    }
  }, [dispatch, HandleCatalogProducts, catalogCategories]);

  const handleDeleteCategory = useCallback(
    async (categoryId: string) => {
      await dispatch(handleDeleteCategoryRequest({ categoryId }));
    },
    [dispatch],
  );

  const headCellsCategories: readonly HeadCell[] = [
    {
      id: "type",
      numeric: false,
      disablePadding: true,
      label: t("categories"),
    },
    {
      id: "action",
      numeric: true,
      disablePadding: false,
      label: "",
    },
  ];

  function createData(type: any, action: any): Data {
    return {
      type,
      action,
    };
  }

  const ActionButton = (data: any, isEdit: any) => {
    if (isEdit?.length) {
      return (
        <div style={{ width: "200px", display: "flex" }}>
          <Styled.ActionContainer
            onClick={() => handleDeleteCategory(data.data.id)}
            color="primary"
            variant="text"
            endIcon={<Delete />}
          >
            {t("delete").toUpperCase()}
          </Styled.ActionContainer>
          <Styled.ActionContainer
            onClick={() => {
              setSelected(data);
              setEdit(true);
            }}
            color="secondary"
            variant="text"
            endIcon={<Edit />}
          >
            {t("edit")}
          </Styled.ActionContainer>
        </div>
      );
    }
    return <div style={{ width: "200px", display: "flex" }}> </div>;
  };

  const ActionEditModal = () => {
    return (
      <UpdateCatalogModal
        isOpen={edit}
        update={selected}
        title="Categoria"
        onClose={() => setEdit(false)}
      />
    );
  };

  const rowsCategories =
    Categories?.data.map((data) => {
      return createData(data.name, <ActionButton data={data} />);
    }) || [];

  return { headCellsCategories, rowsCategories, ActionEditModal };
};
